(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-print"]) return;
  try {
    
    window.addEventListener('load', (e) => {
        window.print();
    });

    window.addEventListener('afterprint', (e) => {
        window.close();
    });

  } catch(e) { console.error(e); }
})();
})();
